// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___1tC5U","items":"styles__items___Hgvvy"};